import React, { useContext, useState } from 'react';
import './ClearAuthorization.css';
import { AccountContext } from '../AccountContext';
import { useMerchantGatewayService, useRefreshAccountAuthorisations, useRefreshLedger, useRefreshPendingAuthorizations } from '@app/sdk';
import { ICellRendererParams } from 'ag-grid-community';

const ClearAuthorization = ({ data }: ICellRendererParams) => {
  const { accountId, setError } = useContext(AccountContext);
  const [amount, setAmount] = useState(data?.remainingAmount as number);
  const [clearing, setClearing] = useState(false as boolean);
  const refreshPendingAuthorizations = useRefreshPendingAuthorizations();
  const refreshAccountAuthorisations = useRefreshAccountAuthorisations();
  const refreshLedger = useRefreshLedger();
  const merchantGatewayService = useMerchantGatewayService();
  const onClearClicked = async () => {
    try {
      setClearing(true);
      await merchantGatewayService.clear(accountId, data?.authorizationId, amount, data?.description);
      setTimeout(() => {
        refreshPendingAuthorizations();
        refreshAccountAuthorisations();
        refreshLedger();
      }, 500);
      setClearing(false);
    } catch (error) {
      setClearing(false);
      setError({ source: 'Clear Transaction', ...error });
    }
  };

  return (
    <div className="field fill">
      <div className="ui labeled input">
        <div className="ui label">£</div>
        <input
          name="amount"
          type="number"
          step=".01"
          min=".01"
          max={data?.remainingAmount}
          defaultValue={data?.remainingAmount}
          onChange={(e) => setAmount(parseFloat(e.target.value))}
          disabled={clearing}
        />
        <button className={`ui right floated fluid button ${clearing ? 'loading' : ''}`} onClick={onClearClicked}>
          Clear
        </button>
      </div>
    </div>
  );
};

export default ClearAuthorization;
